import React from 'react'
import { SprintPacketHydrated } from '@marketing-milk/interfaces'
import { SurfacePalette, type, radius, accentSoft } from '../../tokens'

interface Props {
  palette: SurfacePalette
  packet: SprintPacketHydrated
}

const formatDate = (epochSeconds: number | null | undefined): string | null => {
  if (!epochSeconds) return null
  const d = new Date(epochSeconds * 1000)
  const yyyy = d.getFullYear()
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

export const MarketingMilkHandoffCard = ({ palette, packet }: Props) => {
  const baseUrl = process.env.REACT_APP_NEW_APP_URL
  const businessID = packet.businessID
  const dateFrom = formatDate(packet.sprint?.startTime)
  const dateTo = formatDate(packet.sprint?.endTime)

  const href =
    baseUrl && businessID && dateFrom && dateTo
      ? `${baseUrl}/${businessID}/meta/marketing-funnel?dateFrom=${dateFrom}&dateTo=${dateTo}`
      : null

  const cardStyle: React.CSSProperties = {
    marginTop: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    padding: '14px 16px',
    border: `1px solid ${palette.hairline}`,
    borderRadius: radius.md,
    background: accentSoft,
    fontFamily: type.family.sans,
  }

  const titleStyle: React.CSSProperties = {
    fontSize: type.size.bodyLg,
    fontWeight: type.weight.semibold,
    color: palette.text,
  }

  const subStyle: React.CSSProperties = {
    marginTop: 2,
    fontSize: type.size.body,
    color: palette.textMuted,
  }

  const buttonBase: React.CSSProperties = {
    padding: '8px 14px',
    borderRadius: radius.sm,
    fontFamily: type.family.sans,
    fontSize: type.size.body,
    fontWeight: type.weight.medium,
    letterSpacing: '0.02em',
    border: 'none',
    cursor: href ? 'pointer' : 'not-allowed',
    background: href ? palette.accent : palette.hairline,
    color: href ? palette.accentInk : palette.textFaint,
    textDecoration: 'none',
    whiteSpace: 'nowrap',
  }

  return (
    <div style={cardStyle}>
      <div>
        <div style={titleStyle}>Review in Marketing Milk</div>
        <div style={subStyle}>
          Performance details and the full marketing funnel live in Marketing Milk.
          {dateFrom && dateTo ? ` Dates ${dateFrom} → ${dateTo}.` : ''}
        </div>
      </div>
      {href ? (
        <a href={href} target="_blank" rel="noopener noreferrer" style={buttonBase}>
          Open Marketing Funnel →
        </a>
      ) : (
        <button
          type="button"
          disabled
          title={baseUrl ? 'Sprint date range unavailable' : 'Marketing Milk URL not configured'}
          style={buttonBase}
        >
          Open Marketing Funnel →
        </button>
      )}
    </div>
  )
}
